module.exports = __webpack_public_path__ + "static/images/cbda50e0ce1937246338d2f150f4a597.svg";